module.exports = __webpack_public_path__ + "static/media/sole_ficus.4b462a37.svg";